import styled from "styled-components";

export const CMTimePicker = styled.div((props) => ({
    position: 'absolute',
    top: '5px',
    right: '40px',
    "@media only screen and (max-width: 1629px)": {
        right: '70px',
    },
    "@media only screen and (max-width: 1448px)": {
        right: '100px',
    },
    "@media only screen and (max-width: 1240px)": {
        right: '140px',
    },
    "& .time": {
        display: 'inline-block',
        width: '18vw',
        minWidth: '200px',
        whiteSpace: 'nowrap',

        "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
            minWidth: '290px',
        },
        [`@media ${props.theme.breakpoints.sm}`]: {
            wordBreak: "break-word",
            whiteSpace: "normal"
        },
        "@media only screen and (max-width: 1023px)": {
            display: 'none!important',
        },
    },
}))